export class parametros {
  constructor(
    public action: number,
    public Id: number,
    public datos: any) { }
}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/datos/parametros.ts